import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
const mobile_breakpoint = window.matchMedia('(max-width: 767px)');
let currentInterval;

$('.info-collapse .item-title').on('click', function (e) {
    if (currentInterval !== 'undefined') {
        clearInterval(currentInterval);
        $(this).closest('.section-info-collapse').addClass('-disable-interval');
    }
    if ($(this).hasClass('-active')) {
        $(this).removeClass('-active');
        $(this).next().slideUp();
    } else {
        let open_item = $(this).closest('.info-collapse').find('.item-title.-active');
        let this_item = $(this);
        let header_h = $('.site-header').innerHeight();
        if (mobile_breakpoint.matches === true) {
            open_item.removeClass('-active');
            open_item.next().slideUp(0);
            this_item.addClass('-active');
            this_item.next().slideDown();
            $('html,body').animate({
                scrollTop: this_item.offset().top - header_h
            }, 500);
        } else {
            open_item.removeClass('-active');
            open_item.next().slideUp();
            this_item.addClass('-active');
            this_item.next().slideDown();
        }
    }
});

let section_info_collapse = document.querySelectorAll('.info-collapse');
section_info_collapse.forEach((element, index) => {
    gsap.timeline({
        scrollTrigger: {
            trigger: element,
            endTrigger: element,
            scrub: true,
            onToggle: function (self) {
                if (!element.classList.contains('-disable-interval')) {
                    if (self.isActive) {
                        if (!element.classList.contains('-enable-interval')) {
                            activateFirst(element);
                            element.classList.add('-enable-interval');
                        }
                        startTimer(element);
                    } else {
                        if (currentInterval !== 'undefined') {
                            clearInterval(currentInterval);
                        }
                    }
                }
            },
        }
    });
});

function startTimer(section) {
    currentInterval = setInterval(function () {
        let current_section = $(section);
        let first_item = current_section.find('.item:first-child');
        let open_item_title = current_section.find('.item-title.-active');
        let section_item = current_section.find('.item');
        let open_item = open_item_title.closest('.item');
        let open_item_next = open_item.next();
        let open_item_index = open_item.index() + 1;
        let item_length = section_item.length;

        open_item_title.removeClass('-active');
        open_item_title.next().slideUp(300);
        if (open_item_index === item_length) {
            setTimeout(function () {
                first_item.find('.item-title').addClass('-active');
                first_item.find('.item-title').next().slideDown();
            }, 300);
        } else {
            setTimeout(function () {
                open_item_next.find('.item-title').addClass('-active');
                open_item_next.find('.item-title').next().slideDown();
            }, 300);
        }
    }, 7300);
}
function activateFirst(section) {
    let first_item = $(section).find('.item:first-child');
    first_item.find('.item-title').addClass('-active');
    first_item.find('.item-title').next().slideDown();
}


document.addEventListener("visibilitychange", function(){
    if (document.hidden){
        if (currentInterval !== 'undefined') {
            clearInterval(currentInterval);
            $('.section-info-collapse .info-collapse').addClass('-disable-interval');
        }
    }
});

//animation parallax content
(function ($) {
    $(document).ready(function () {
        if ($(".group-1").length) {
            $(".group-1").parallaxContent({
                shift: 30,
                duration: 1.5
            });
        }
        if ($(".group-2").length) {
            $(".group-2").parallaxContent({
                shift: -30,
                duration: 1
            });
        }

        if ($(".group-3").length) {
            $(".group-3").parallaxContent({
                shift: 40,
                duration: 1.5
            });
        }

        if ($(".group-3-1").length) {
            $(".group-3-1").parallaxContent({
                shift: -40,
                duration: 1.5
            });
        }

        if ($(".group-4").length) {
            $(".group-4").parallaxContent({
                shift: 50,
                duration: 1
            });
        }
    });
})(jQuery);